import { render, staticRenderFns } from "./comissionamento.vue?vue&type=template&id=2bc3571c&scoped=true"
import script from "./comissionamento.vue?vue&type=script&lang=js"
export * from "./comissionamento.vue?vue&type=script&lang=js"
import style0 from "./comissionamento.vue?vue&type=style&index=0&id=2bc3571c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3571c",
  null
  
)

export default component.exports